module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-5-18bcfbe130970ee91cfcb0c3dde73a45.jpg";